/**
 * Shared Axios client for webwalker-billing `/api/admin` (`VUE_APP_ROOT_API`).
 * Domain modules under src/api/*Api.js call this; Bearer comes from Vuex token.
 * Read-only: customers, subscriptions, plans, products, invoices.
 * CRUD: corporations, investors, investments, accounts, expenses, transactions, documents.
 */
import axios from "axios";
import store from "@/store";

let CoreApi = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
});

let Api = function() {
  if (store.state.token) {
    CoreApi.defaults.headers.common["Authorization"] = 'Bearer ' + store.state.token;
  } else {
    delete CoreApi.defaults.headers.common["Authorization"];
  }

  return CoreApi;
};

export default Api;
